import {Fancybox} from '@fancyapps/ui';
import "@fancyapps/ui/dist/fancybox.css"

VIV.behaviours.blockImages = (function (){

    const attach = function (context) {

        const blockName = 'slideBlock';
        const blocks = context.querySelectorAll(`.${blockName}`);

        if (blocks.length === 0) {
            return;
        }

        Fancybox.bind("[data-fancybox]", {
            infinite: false,
            preload: 0,
        });
    };

    return {
        attach: attach
    }
})();
